<template>
<!-- eslint-disable -->
<div class="v-docs">
<div class="markdown-body"><h1>Button</h1>
<p>A button component for vue.</p>
<pre class="language language-js" data-lang="js"><code v-html="'&lt;span class=&quot;hljs-keyword&quot;&gt;import&lt;/span&gt; { Button &lt;span class=&quot;hljs-keyword&quot;&gt;as&lt;/span&gt; VcButton, ButtonGroup &lt;span class=&quot;hljs-keyword&quot;&gt;as&lt;/span&gt; VcButtonGroup } &lt;span class=&quot;hljs-keyword&quot;&gt;from&lt;/span&gt; &lt;span class=&quot;hljs-string&quot;&gt;\'@dove-ui/vc-button\'&lt;/span&gt;\n&lt;span class=&quot;hljs-keyword&quot;&gt;import&lt;/span&gt; &lt;span class=&quot;hljs-string&quot;&gt;\'@dove-ui/vc-button/dist/index.css\'&lt;/span&gt;\n'"></code></pre>
<pre class="language language-html" data-lang="html"><code v-html="'&lt;span class=&quot;hljs-tag&quot;&gt;&amp;lt;&lt;span class=&quot;hljs-name&quot;&gt;vc-button&lt;/span&gt;&amp;gt;&lt;/span&gt;Button&lt;span class=&quot;hljs-tag&quot;&gt;&amp;lt;/&lt;span class=&quot;hljs-name&quot;&gt;vc-button&lt;/span&gt;&amp;gt;&lt;/span&gt;\n\n&lt;span class=&quot;hljs-tag&quot;&gt;&amp;lt;&lt;span class=&quot;hljs-name&quot;&gt;vc-button-group&lt;/span&gt;&amp;gt;&lt;/span&gt;\n  &lt;span class=&quot;hljs-tag&quot;&gt;&amp;lt;&lt;span class=&quot;hljs-name&quot;&gt;vc-button&lt;/span&gt;&amp;gt;&lt;/span&gt;Button&lt;span class=&quot;hljs-tag&quot;&gt;&amp;lt;/&lt;span class=&quot;hljs-name&quot;&gt;vc-button&lt;/span&gt;&amp;gt;&lt;/span&gt;\n  &lt;span class=&quot;hljs-tag&quot;&gt;&amp;lt;&lt;span class=&quot;hljs-name&quot;&gt;vc-button&lt;/span&gt;&amp;gt;&lt;/span&gt;Button&lt;span class=&quot;hljs-tag&quot;&gt;&amp;lt;/&lt;span class=&quot;hljs-name&quot;&gt;vc-button&lt;/span&gt;&amp;gt;&lt;/span&gt;\n&lt;span class=&quot;hljs-tag&quot;&gt;&amp;lt;/&lt;span class=&quot;hljs-name&quot;&gt;vc-button-group&lt;/span&gt;&amp;gt;&lt;/span&gt;\n'"></code></pre>
<p><img src="screenshot.png" alt=""></p>
<h3>Button Attributes</h3>
<table>
<thead>
<tr>
<th>Attribute</th>
<th>Description</th>
<th>Type</th>
<th>Accepted Values</th>
<th>Default</th>
</tr>
</thead>
<tbody>
<tr>
<td>type</td>
<td>type</td>
<td>string</td>
<td><code>default</code>,<code>info</code>,<code>primary</code>,<code>warning</code>,<code>danger</code>,<code>success</code>,<code>text</code></td>
<td><code>default</code></td>
</tr>
<tr>
<td>size</td>
<td>size</td>
<td>string</td>
<td><code>large</code>,<code>medium</code>,<code>samll</code>,<code>mini</code></td>
<td>—</td>
</tr>
<tr>
<td>plain</td>
<td>plain</td>
<td>boolean</td>
<td>—</td>
<td>false</td>
</tr>
<tr>
<td>round</td>
<td>round</td>
<td>boolean</td>
<td>—</td>
<td>false</td>
</tr>
<tr>
<td>disabled</td>
<td>disabled</td>
<td>boolean</td>
<td>—</td>
<td>false</td>
</tr>
<tr>
<td>block</td>
<td>block</td>
<td>boolean</td>
<td>—</td>
<td>false</td>
</tr>
<tr>
<td>loading</td>
<td>loading state</td>
<td>boolean</td>
<td>—</td>
<td>false</td>
</tr>
<tr>
<td>native-type</td>
<td>native type</td>
<td>string</td>
<td><code>button</code> / <code>submit</code> / <code>reset</code></td>
<td><code>button</code></td>
</tr>
</tbody>
</table>
</div>
</div>
</template>

    <script>
      /** eslint-disable **/
      

      
      
      export default {
        components: {
          
        },
        mixins: [
          
        ]
      }
    </script>
